hns('I18n.publicLocales', {
  "af": {
    "language": "af",
    "beta": false,
    "defaultLocale": "af",
    "availableLocale": [
      "af"
    ]
  },
  "ar-eg": {
    "language": "ar-eg",
    "beta": false,
    "defaultLocale": "ar-eg",
    "availableLocale": [
      "ar-eg"
    ]
  },
  "bg": {
    "language": "bg",
    "beta": false,
    "defaultLocale": "bg",
    "availableLocale": [
      "bg"
    ]
  },
  "bn": {
    "language": "bn",
    "beta": false,
    "defaultLocale": "bn",
    "availableLocale": [
      "bn"
    ]
  },
  "ca-es": {
    "language": "ca-es",
    "beta": false,
    "defaultLocale": "ca-es",
    "availableLocale": [
      "ca-es"
    ]
  },
  "cs": {
    "language": "cs",
    "beta": false,
    "defaultLocale": "cs",
    "availableLocale": [
      "cs"
    ]
  },
  "da": {
    "language": "da",
    "beta": false,
    "defaultLocale": "da",
    "availableLocale": [
      "da"
    ]
  },
  "el": {
    "language": "el",
    "beta": false,
    "defaultLocale": "el",
    "availableLocale": [
      "el"
    ]
  },
  "en-gb": {
    "language": "en-gb",
    "beta": false,
    "defaultLocale": "en-gb",
    "availableLocale": [
      "en-gb"
    ]
  },
  "es-mx": {
    "language": "es-mx",
    "beta": false,
    "defaultLocale": "es-mx",
    "availableLocale": [
      "es-mx"
    ]
  },
  "fr-ca": {
    "language": "fr-ca",
    "beta": false,
    "defaultLocale": "fr-ca",
    "availableLocale": [
      "fr-ca"
    ]
  },
  "he-il": {
    "language": "he-il",
    "beta": false,
    "defaultLocale": "he-il",
    "availableLocale": [
      "he-il"
    ]
  },
  "hr": {
    "language": "hr",
    "beta": false,
    "defaultLocale": "hr",
    "availableLocale": [
      "hr"
    ]
  },
  "hu": {
    "language": "hu",
    "beta": false,
    "defaultLocale": "hu",
    "availableLocale": [
      "hu"
    ]
  },
  "id": {
    "language": "id",
    "beta": false,
    "defaultLocale": "id",
    "availableLocale": [
      "id"
    ]
  },
  "ko": {
    "language": "ko",
    "beta": false,
    "defaultLocale": "ko",
    "availableLocale": [
      "ko"
    ]
  },
  "lt": {
    "language": "lt",
    "beta": false,
    "defaultLocale": "lt",
    "availableLocale": [
      "lt"
    ]
  },
  "ms": {
    "language": "ms",
    "beta": false,
    "defaultLocale": "ms",
    "availableLocale": [
      "ms"
    ]
  },
  "no-no": {
    "language": "no-no",
    "beta": false,
    "defaultLocale": "no-no",
    "availableLocale": [
      "no-no"
    ]
  },
  "ro": {
    "language": "ro",
    "beta": false,
    "defaultLocale": "ro",
    "availableLocale": [
      "ro"
    ]
  },
  "ru": {
    "language": "ru",
    "beta": false,
    "defaultLocale": "ru",
    "availableLocale": [
      "ru"
    ]
  },
  "sk": {
    "language": "sk",
    "beta": false,
    "defaultLocale": "sk",
    "availableLocale": [
      "sk"
    ]
  },
  "sl": {
    "language": "sl",
    "beta": false,
    "defaultLocale": "sl",
    "availableLocale": [
      "sl"
    ]
  },
  "th": {
    "language": "th",
    "beta": false,
    "defaultLocale": "th",
    "availableLocale": [
      "th"
    ]
  },
  "tl": {
    "language": "tl",
    "beta": false,
    "defaultLocale": "tl",
    "availableLocale": [
      "tl"
    ]
  },
  "tr": {
    "language": "tr",
    "beta": false,
    "defaultLocale": "tr",
    "availableLocale": [
      "tr"
    ]
  },
  "uk": {
    "language": "uk",
    "beta": false,
    "defaultLocale": "uk",
    "availableLocale": [
      "uk"
    ]
  },
  "vi": {
    "language": "vi",
    "beta": false,
    "defaultLocale": "vi",
    "availableLocale": [
      "vi"
    ]
  },
  "zh-cn": {
    "language": "zh-cn",
    "beta": false,
    "defaultLocale": "zh-cn",
    "availableLocale": [
      "zh-cn"
    ]
  },
  "zh-hk": {
    "language": "zh-hk",
    "beta": false,
    "defaultLocale": "zh-hk",
    "availableLocale": [
      "zh-hk"
    ]
  },
  "zh-tw": {
    "language": "zh-tw",
    "beta": false,
    "defaultLocale": "zh-tw",
    "availableLocale": [
      "zh-tw"
    ]
  }
});